export default __webpack_public_path__ + "static/media/error-404-monochrome.a0894fb6.svg";